exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section_info{background:#fff;padding:20px 0}.section_info .main_text{font-size:18px;text-align:justify}.section_info .main_btn{text-align:center;margin-top:15px}.section_info .main_btn button{background:#94bd25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-459ca497","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Info.vue
// module id = 245
// module chunks = 0